module.exports = __webpack_public_path__ + "img/INGREDIENTES.bc5a99f0.png";